import Numeral from 'numeral';
import Config from '../../components/Util/Constantes';

//DD:HH:MM:SS
export const toDDHHMMSS = (pSegundos) => {
    if (pSegundos < 0) {
        pSegundos = pSegundos * -1;
    }

    const seccionesTiempo = [
        Math.floor(pSegundos / 86400), // DAYS
        Math.floor(pSegundos / 3600) % 24, // HOURS
        Math.floor(pSegundos / 60) % 60, // MINUTES
        pSegundos % 60 // SECONDS
    ];

    return seccionesTiempo.map((valor, indice) => {
        if (indice === 0 && valor === 0) { // Si no tiene dias se omite el 00:
            return '';
        } else {
            if (indice === 3) {
                return (((valor < 10) ? '0' : '') + valor.toString());
            } else {
                return (((valor < 10) ? '0' : '') + valor.toString()) + ":";
            }
        }
    });
};

export const groupBy = (array, fn) => array.reduce((result, item) => {
    const key = fn(item);
    if (!result[key]) result[key] = [];
    result[key].push(item);
    return result;
}, {});

export const checkEmail = (value) => {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return pattern.test(value);
};

export function farmatearMontos(valor) {
    let _formato = formatoMon();
    return Numeral(valor).format(_formato);
};

export function formatearCantidad(pValor, pPermiteDecimales = false, pCantidadDecimales = 2) {
    let _formato = pPermiteDecimales ? `0.${'0'.padStart(pCantidadDecimales, '0')}` : '0';
    return Numeral(pValor).format(_formato);
};

export function formatoCant() {
    //const localStorage = new LocalStorage();
    let _Formatos = null;//localStorage.get('Formatos');se sacaba de webconfig
    let pResultado = '0';
    try {
        if (_Formatos) {
            pResultado = _Formatos.Formato.FormatoCant;
        } else {
            pResultado = '0';
        }
        return pResultado;
    }
    catch (err) {
        return '0';
    }
};

export function formatoMon() {
    let pResultado = '0.00';
    //const localStorage = new LocalStorage();
    let _Formatos = "###,###,##0.00";//null;//localStorage.get('Formatos');   se sacaba de webconfig
    try {
        if (_Formatos) {
            pResultado = _Formatos;//.Formato.FormatoMon ;
        } else {
            pResultado = '0.0';
        }
        return pResultado;
    }
    catch (err) {
        return '0.0';
    }
};

export function llenar_Derecha(pLargoMax, pCadena, pRelleno) {
    return ((pRelleno.repeat(pLargoMax - pCadena.length)) + pCadena);
};

export function validarInt(pValor) {
    let isValid = true;
    if (pValor.toString().length > 0) {
        const pattern = /^\d+$/;
        isValid = !isNaN(pValor) && pattern.test(pValor) && !isNaN(parseInt(pValor));
        isValid = isValid && parseInt(pValor) <= 2147483647;
    }
    return isValid;
};

export function Retorna_Nombre_Estado_Orden(pEstado) {
    let _Nombre_Estado = "";
    switch (pEstado) {
        case Config.c_Estatus_Operador:
            _Nombre_Estado = "Orden";
            break;
        case Config.c_Estatus_Despachada:
            _Nombre_Estado = "Despacho";
            break;
        case Config.c_Estatus_Facturada:
            _Nombre_Estado = "Facturado"
            break;
        case Config.c_Estatus_Ruta:
            _Nombre_Estado = "Ruta";
            break;
        case Config.c_Estatus_Borrada:
            _Nombre_Estado = "Borrada";
            break;
        case Config.c_Estatus_Espera:
            _Nombre_Estado = "Espera";
            break;
        case Config.c_Estatus_Pospuesta:
            _Nombre_Estado = "Pospuesta";
            break;
        case Config.c_Estatus_Modificando:
            _Nombre_Estado = "Modificando";
            break;
        case Config.c_Estatus_Terminada:
            _Nombre_Estado = "Terminado";
            break;
        case Config.c_Estatus_Venta:
            _Nombre_Estado = "Venta"
            break;
        case Config.c_Estatus_Impresa:
            _Nombre_Estado = "Impresa";
            break;
    }
    return _Nombre_Estado;
};

export const AUTHORIZE_TYPES = {
    CREDOMATIC_CARDINAL: 'CREDOMATIC_CARDINAL',
    CREDOMATIC_FAC: 'CREDOMATIC_FAC',
    CREDOMATIC_FAC_3DS: 'CREDOMATIC_FAC_2'
};

export const countDecimals = function (value) {
    if (Math.floor(value) !== value) {
        let partes = value.toString().split(".");
        if (partes.length === 1) {
            partes = value.toString().split(",");
        }
        return partes[1].length || 0;
    }
    return 0;
};